export const resolveBasicNavigationSelectedValue = (
  activeSection: number | undefined,
  pendingNaviClick: number | null
): number | undefined => pendingNaviClick ?? activeSection;
